module.exports = __webpack_public_path__ + "static/img/wx_qr_code.891d4e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/wx_qr_code.jpg
// module id = FGD8
// module chunks = 1